/** @jsx jsx */
import { jsx, Alert as ThemeAlert, Close } from 'theme-ui'
import styled from '@emotion/styled'
import Body from '../Typography/Body/Body'
import Exclamation from '../../../icons/Exclamation.svg'

const StyledAlert = styled(ThemeAlert)`
  line-weight: 'normal';
`

const Alert = ({
  children,
  bodyVariant = 'body2',
  exclamation,
  close,
  ...props
}) => {
  return (
    <StyledAlert {...props}>
      {exclamation && <img src={Exclamation} alt="exclamation" />}
      <Body
        variant={bodyVariant}
        sx={{
          marginLeft: exclamation && '10px',
          height: '100%',
          fontSize: 1,
          fontWeight: 400,
        }}
      >
        {children}
      </Body>
      {close && (
        <Close
          sx={{
            marginLeft: '915px',
            width: '28px',
            height: '28px',
          }}
        />
      )}
    </StyledAlert>
  )
}

export default Alert
